import type { ReactNode } from 'react';

type ToolbarFormatGroupProps = {
  children: ReactNode;
};

export function ToolbarFormatGroup({ children }: ToolbarFormatGroupProps) {
  return <div className="ql-format-group">{children}</div>;
}
ToolbarFormatGroup.displayName = 'RichTextEditor_ToolbarFormatGroup';
